const common = {
  phone: "(702) 604-2093",
  phoneRaw: "+17026042093",
  callNow: "Call Now",
  getFreeQuote: "Get Free Quote",
  getMyFreeEstimate: "Get My Free Estimate",
  freeEstimate: "Free Estimate",
  viewAllServices: "View All Services",
  viewAllServiceAreas: "View All Service Areas",
  viewFullGallery: "View Full Gallery",
  learnMore: "Learn More",
  sendingLabel: "Sending...",
  requestReceived: "Request Received!",
  requestReceivedDesc: "We'll contact you within 24 hours with your free estimate.",
  fullName: "Full Name",
  phone_field: "Phone",
  email: "Email",
  serviceNeeded: "Service Needed",
  message: "Message",
  selectService: "Select a service...",
  describeProject: "Describe your project...",
  tellUsProject: "Tell us about your project...",
  submitConsent: "By submitting, you agree to be contacted about your project.",
  noObligation: "No obligation. We'll respond within 24 hours.",
  nav_home: "Home",
  nav_services: "Services",
  nav_areas: "Service Areas",
  nav_blog: "Blog",
  lang_en: "EN",
  lang_es: "ES",
  switchLang: "Español",
  footerTagline: "Premium Glass & Mirror Solutions",
  footerDesc: "Precision-crafted glass installations for homes and businesses across the Las Vegas Valley. Frameless, modern, and built to last.",
  footerServices: "Services",
  footerAreas: "Service Areas",
  footerCompany: "Company",
  footerRights: "All rights reserved. Las Vegas, NV.",
  privacy: "Privacy Policy",
  terms: "Terms of Service",
  stayUpdated: "Stay Updated",
  subscribe: "Subscribe",
};

export default common;
